import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/icon-yen-blue.svg'
import _imports_1 from '@/assets/img/common/icon-pin-blue.svg'
import _imports_2 from '@/assets/img/common/icon-comment-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-04d0d61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-top-job_item splide__slide" }
const _hoisted_2 = { class: "p-jobsearch-card_inner" }
const _hoisted_3 = { class: "p-jobsearch-card_header" }
const _hoisted_4 = { class: "p-jobsearch-tag01" }
const _hoisted_5 = {
  key: 0,
  class: "p-jobsearch-tag01_item __closed js-tooltip-open-button"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "募集終了", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip js-tooltip-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_inner" }, [
    /*#__PURE__*/_createElementVNode("p", null, "募集終了ではありますが、応募対応は可能です。同企業の別ポディションで検討いたします。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_close js-tooltip-close-trigger" }, "閉じる")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "p-jobsearch-heading word_break" }
const _hoisted_10 = { class: "p-jobsearch-company" }
const _hoisted_11 = { class: "p-jobsearch-tit" }
const _hoisted_12 = { class: "p-jobsearch-tag02" }
const _hoisted_13 = {
  key: 0,
  class: "p-jobsearch-tag02_item __welcome"
}
const _hoisted_14 = {
  key: 1,
  class: "p-jobsearch-tag02_item __blank"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "p-top-card-job_info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("年収")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("勤務地")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("担当者コメント")
], -1))
const _hoisted_20 = { class: "-full word-break" }
const _hoisted_21 = { class: "p-top-card-job_button" }
const _hoisted_22 = { class: "p-jobsearch-buttons" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_24 = { class: "p-jobsearch-heart js-heart __animation" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

import { ref } from 'vue';
import { Job } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendedJobCard',
  props: {
    job: null
  },
  emits: ['update:favorite'],
  setup(__props: any, { emit }) {





const handleFavoriteChange = (event: Event) => {
  emit('update:favorite', (event.target as HTMLInputElement).checked);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-jobsearch-card", __props.job.recruitClosed ? '__closed' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (__props.job.recruitClosed)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_8))
              : _createCommentVNode("", true),
            (__props.job.isRecommendedByStaff)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                }, "担当者おすすめ", 2))
              : _createCommentVNode("", true),
            (__props.job.isRecommendedByClient)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                }, "弊社企業担当おすすめ", 2))
              : _createCommentVNode("", true),
            (__props.job.isNewRecommended)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                }, "新着レコメンド", 2))
              : _createCommentVNode("", true),
            (__props.job.isAiRecommended)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                }, "AIおすすめ", 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.job.companyName), 1),
            _createElementVNode("h2", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: `/jobsearch/detail/${__props.job.orderId}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.job.jobTitle), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("ul", _hoisted_12, [
            (__props.job.isWelcome)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, "応募歓迎"))
              : _createCommentVNode("", true),
            (__props.job.pickupLink)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createElementVNode("a", {
                    href: __props.job.pickupLink || '#',
                    target: "_blank"
                  }, "PICK UP", 8, _hoisted_15)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("dl", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("dd", null, _toDisplayString(__props.job.annualIncome), 1),
          _hoisted_18,
          _createElementVNode("dd", null, _toDisplayString(__props.job.workLocation), 1),
          (__props.job.staffComment)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_19,
                _createElementVNode("dd", _hoisted_20, _toDisplayString(__props.job.staffComment), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, {
              class: "p-jobsearch-btn __white __link",
              to: `/jobsearch/detail/${__props.job.orderId}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 詳細を見る "),
                _hoisted_23
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("label", _hoisted_24, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: __props.job.isFavorite || __props.job.isLiked,
                onChange: handleFavoriteChange
              }, null, 40, _hoisted_25),
              _hoisted_26,
              _hoisted_27,
              _hoisted_28
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})